import { Checkout } from '@public/Showroom/Checkout'

Checkout.seoProps = {
  description: 'Review your order and select shipping method.',
}

export default Checkout
